import NavigateIconButton from 'components/Control/NavigateIconButton'
import LinkIcon from 'components/Control/LinkIcon'
import RatesCalendarPreviewAction from 'components/Page/Rates/RatesCalendarPreviewAction'
import SendEmailAction from 'Page/SendEmail/SendEmailAction'

const tableHeaderActions = {
    invoices: [{ActionComponent: LinkIcon, link: 'invoices/export', title: 'Export'}],
    rates: [
        {
            ActionComponent: NavigateIconButton,
            to: '/rates/new',
            titleKey: 'rates.calendar.action',
            showOn: ['large'],
            // size: 'small',
        },
        {
            ActionComponent: RatesCalendarPreviewAction,
            showOn: ['large'],
            // size: 'small',
        },
    ],
    email_broadcasts: [{ActionComponent: SendEmailAction}],
}
export default tableHeaderActions
